import React, { useEffect, useState } from "react";

export default function SubVariantInventoryInput({
  variantUiId,
  comboList,
  setComboList,
}) {
  const original = comboList.find((c) => c.variantUiId === variantUiId);
  const isTracked = !!original?.trackInventory;

  const formatWithCommas = (n) => {
    if (n === null || n === undefined || n === "") return "";
    const v = parseInt(String(n).replace(/,/g, ""), 10);
    if (isNaN(v)) return "";
    return v.toLocaleString();
  };

  const [tempValue, setTempValue] = useState(() =>
    isTracked && typeof original?.inventoryQuantity === "number"
      ? formatWithCommas(original.inventoryQuantity)
      : (isTracked ? "" : "--")
  );

  // Sync when comboList or tracking changes
  useEffect(() => {
    if (!isTracked) { setTempValue("--"); return; }
    const v = original?.inventoryQuantity;
    setTempValue(typeof v === "number" ? formatWithCommas(v) : "");
  }, [isTracked, original?.inventoryQuantity]);

  const handleChange = (e) => {
    if (!isTracked) return;
    const digits = String(e.target.value || "").replace(/\D/g, "");
    setTempValue(digits);
  };

  const handleBlur = () => {
    if (!isTracked) return;
    const digits = String(tempValue || "").replace(/\D/g, "");
    if (digits === "") {
      setComboList((prev) =>
        prev.map((combo) =>
          combo.variantUiId === variantUiId
            ? { ...combo, inventoryQuantity: "", meta: { ...(combo.meta || {}), inventoryDirty: true } }
            : combo
        )
      );
      setTempValue("");
      return;
    }
    const val = parseInt(digits, 10);
    if (isNaN(val) || val < 0) { setTempValue(""); return; }

    setComboList((prev) =>
      prev.map((combo) =>
        combo.variantUiId === variantUiId
          ? { ...combo, inventoryQuantity: val, meta: { ...(combo.meta || {}), inventoryDirty: true } }
          : combo
      )
    );
    setTempValue(formatWithCommas(val));
  };

  return (
    <div className="flex-1 max-w-[7em]" onClick={(e) => e.stopPropagation()}>
      <input
        type="text"
        inputMode={isTracked ? "numeric" : undefined}
        pattern={isTracked ? "[0-9]*" : undefined}
        disabled={!isTracked}
        className={`border border-[#8e8e8e] w-full py-[5px] px-[5px] rounded text-[14px] font-medium ${!isTracked ? "text-[#8c8c8c] bg-[#efefef] cursor-not-allowed" : ""}`}
        value={tempValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={(e) => {
          if (!isTracked) { e.preventDefault(); return; }
          if (["e", "E", "+", "-", "."].includes(e.key)) {
            e.preventDefault();
          }
        }}
        placeholder={isTracked ? "0" : undefined}
      />
    </div>
  );
}
